import {rtbHouse} from '../../../externalTrackers/index.js'
import {
  AD_FAVORITED_EVENT_NAME,
  ALERT_CREATED_EVENT_NAME,
  DETAIL_VIEWED_EVENT_NAME,
  getPixelEvents,
  HOME_VIEWED_EVENT_NAME,
  LEAD_TRIGGERED_EVENT_NAME,
  LIST_VIEWED_EVENT_NAME,
  OFFER_TYPE_HOME_CAROUSEL_CLICKED_EVENT_NAME
} from './data.js'

const track = rtbHouse({id: 'i87bcT6BOOlj1IGYN66P'})
const eventsMapping = {
  [HOME_VIEWED_EVENT_NAME]: 'home',
  [LIST_VIEWED_EVENT_NAME]: 'listing',
  [DETAIL_VIEWED_EVENT_NAME]: 'offer',
  [LEAD_TRIGGERED_EVENT_NAME]: 'conversion',
  [AD_FAVORITED_EVENT_NAME]: 'wishlist',
  [ALERT_CREATED_EVENT_NAME]: 'wishlist',
  [OFFER_TYPE_HOME_CAROUSEL_CLICKED_EVENT_NAME]: 'category'
}
const allowedEvents = Object.keys(eventsMapping)

export default ({event, properties, isPage}) => {
  const needsToTrack = allowedEvents.includes(event) || isPage

  if (needsToTrack) {
    const mappedEvent = eventsMapping[event]
    const pixelEvents = getPixelEvents({event, properties, mappedEvent, isPage})

    track({event: mappedEvent, pixelEvents})
  }
}
